import AttachmentsSidebarWidgetModule from './attachments-sidebar-widget.module'

export default AttachmentsSidebarWidgetModule
